import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withStyles, Dialog, Button } from "@material-ui/core";

import "../../styles/PopUp.scss";

import popup from '../../stores/PopupStore';

const styles = {
  popupstyle: {
    width: "100%",
  },
  popupTitle: {
    width: "100%",
  },
  iconStyle: {
    alignSelf: "center",
    marginRight: "10px",
  },
};

const component = observer(class PopUpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      full: false,
    };
  }

  hide = () => {
    popup.hidePopup();
  };

  renderButtons = (btn) => {
    let action;

    if (btn.close) {
      action = this.hide;
    } else {
      action = btn.action;
    }

    return (
      <Button
        id="btnPopUp"
        variant="contained"
        color="primary"
        onClick={action}
        key={btn.label}
        className="btnRipley"
        fullWidth={btn.full}
      >
        {btn.label}
      </Button>
    );
  };

  renderButtonsBox = () => {
    let buttonBox;
    if (this.props.btns) {
      buttonBox = (
        <div className="boxButton">
          {this.props.btns.map((btn) => this.renderButtons(btn))}
        </div>
      );
    }
    return buttonBox;
  };

  render() {
    let content = '';
    if (popup.popupData.loading === false) {
      content = this.renderButtonsBox();
    } else {
      // content = this.renderLoading();
    }
    return (
      <Dialog id="modal" modal="true" open={popup.popupData.show}>
        <div className="Panel">
          <div className="titlePopup">
            <p id="txtTituloModal" style={styles.popupTitle}>
              {this.props.title}
            </p>
          </div>
          <div className="boxMensaje">
            <div className="mensaje">
              <p id="txtModal">{this.props.message}</p>
            </div>
            {content}
          </div>
          <div className="franjaColores">
            <div className="rojo" />
            <div className="amarillo" />
            <div className="morado" />
          </div>
        </div>
      </Dialog>
    );
  }
});

component.propTypes = {
  classes: PropTypes.object.isRequired,
};

const PopUp = withStyles(styles)(component);
export default PopUp;
